<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="mx-2">
    <v-col cols="12" class="text-center pa-0">
      <v-textarea ref="smsMessage"
                  background-color="kbLight"
                  :height="shortHeight ? '90px' : ''"
                  color="kbDarkBlueText"
                  v-model="sms.message"
                  class="text-center"
                  style="margin: auto"
                  :style="{ maxWidth: $vuetify.smAndDown ? '100%' : '600px' }"
                  :label="$t('general.writeYourMessageHere')"
                  single-line
                  clearable
                  persistent-hint
                  :hint="getMultipartsFromMessage"
                  :rules="[rules.required]"
                  solo
                  v-on="{click: signalSmsMsgHandler, keyup: signalSmsMsgHandler}"/>
    </v-col>

    <v-col class="d-flex justify-center align-center pt-0" cols="12">
      <btn-customize-field  :color="color"
                            propModif="message"
                            :itemToCustomize="$t('general.message')"
                            domElemCursorPosition="smsMsgCaretPosition"
                            accessDataObject="sms"
                            @customizeMessage="customizeMessage"/>
      <v-btn :color="color"
             class="ml-2"
             dark
             :fab="$vuetify.breakpoint.smAndDown"
             :loading="sendingSms"
             :small="$vuetify.breakpoint.smAndDown"
             @click="sendSms()"
             v-if="showSendButton">
        <v-icon color="white">mdi-send</v-icon>
        <span class="hidden-sm-and-down">
          {{ $t('general.sendSms') }}
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import BtnCustomizeField from '@/pages/App/Communications/CustomizeFields/BtnCustomizeField.vue'
import customMessages from '@/libs/customMessages'
import rules from '@/libs/rules'
import smssplit from '@/libs/smssplit.js'
export default {
  components: { BtnCustomizeField },
  computed: {
    getMultipartsFromMessage () {
      if (!this.sms.message) return
      let totalMultiparts = 1
      try {
        const inputCharacters = smssplit.util.unicodeCharacters(this.sms.message)
        const totalSegments = smssplit.segmenter.gsm(inputCharacters)
        if (totalSegments && totalSegments.length > 0) {
          totalMultiparts = totalSegments.length
        }
      } catch (e) {
        console.error(e)
      }

      return `${this.sms.message.length} caracter${this.sms.message.length > 1 ? 'es' : ''} - ${totalMultiparts} parte${totalMultiparts > 1 ? 's  ' : ''}`
    }
  },
  data () {
    return {
      smsMsgCaretPosition: 0,
      rules
    }
  },
  methods: {
    sendSms () {
      this.$emit('sendSms')
    },
    signalSmsMsgHandler (event) {
      const textarea = this.$refs.smsMessage.$refs.input
      const cursorPosition = textarea.selectionStart
      this.smsMsgCaretPosition = cursorPosition
    },
    customizeMessage (item, propModif, domElemCaretPostion, accessDataObject) {
      const src = this[accessDataObject][propModif]
      const caretPos = this[domElemCaretPostion]
      const value = ` ${item.value} `
      this[accessDataObject][propModif] = customMessages.customizeMessage(value, src, caretPos)
      this[domElemCaretPostion] = caretPos + value.length
    }
  },
  props: {
    color: {
      type: String,
      default: 'kbPurple'
    },
    sendingSms: {
      type: Boolean,
      default: false
    },
    showSendButton: {
      type: Boolean,
      default: false
    },
    shortHeight: {
      type: Boolean,
      default: false
    },
    sms: {
      type: Object,
      required: true
    }
  }
}
</script>
